import { getSailings } from '../../api/api'

export const actionTypes = {
  FETCH_START: 'sailings/FETCH_START',
  FETCH_SUCCESS: 'sailings/FETCH_SUCCESS',
  FETCH_ERROR: 'sailings/FETCH_ERROR',
}

export const fetchSailings = () => async (dispatch) => {
  dispatch({ type: actionTypes.FETCH_START })

  try {
    const { data } = await getSailings()
    return dispatch({ type: actionTypes.FETCH_SUCCESS, payload: data })
  } catch (error) {
    return dispatch({ type: actionTypes.FETCH_ERROR })
  }
}
